import { TABLE_DEFAULT_CURRENT_PAGE, TABLE_DEFAULT_PAGE_SIZE } from '../AppConstants';

export const getPaginatorParamsFromURL = (searchParams: URLSearchParams) => {
    const currPageParam = searchParams.get('page');
    const pageSizeParam = searchParams.get('pageSize');

    const numCurrPage = currPageParam ? parseInt(currPageParam, 10) : TABLE_DEFAULT_CURRENT_PAGE;
    const numPageSize = pageSizeParam ? parseInt(pageSizeParam, 10) : TABLE_DEFAULT_PAGE_SIZE;

    return {
        pageIndex: numCurrPage,
        pageSize: numPageSize
    };
};
